import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import { Outside } from '../../outside';
import { processKeyboardEvent } from './utils/processKeyboardEvent';
export var SelectContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(SelectContainer, _React$Component);

  var _super = _createSuper(SelectContainer);

  function SelectContainer() {
    var _this;

    _classCallCheck(this, SelectContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "isMouseDown", false);

    _defineProperty(_assertThisInitialized(_this), "handleMouseDown", function () {
      _this.isMouseDown = true;
      document.addEventListener('mouseup', _this.handleDocumentMouseUp);
    });

    _defineProperty(_assertThisInitialized(_this), "handleDocumentMouseUp", function () {
      _this.isMouseDown = false;
      document.removeEventListener('mouseup', _this.handleDocumentMouseUp);
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function () {
      if (!_this.isMouseDown && _this.props.opened) {
        _this.props.actions.closeDropdown();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      processKeyboardEvent(e, {
        multiple: _this.props.multiple,
        opened: _this.props.opened,
        actions: _this.props.actions
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOutside", function () {
      if (_this.props.opened) {
        _this.props.actions.closeDropdown();
      }
    });

    return _this;
  }

  _createClass(SelectContainer, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mouseup', this.handleDocumentMouseUp);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Outside, {
        onOutside: this.handleOutside
      }, /*#__PURE__*/React.createElement("div", {
        ref: this.props.forwardedRef,
        className: this.props.className,
        tabIndex: this.props.disabled ? -1 : this.props.tabIndex || 0,
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleMouseDown,
        onBlur: this.handleBlur,
        style: this.props.style
      }, this.props.children));
    }
  }]);

  return SelectContainer;
}(React.Component);